<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Dienst toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddPackageDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <div class="hogans-alerts">
      <v-alert v-if="feedback" :value="true" type="warning">{{
        feedback
      }}</v-alert>
    </div>

    <v-divider></v-divider>

    <v-card-text>
      <v-text-field
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        label="Titel"
        v-model="newPackage.title"
        :rules="requiredRules"
        required
      ></v-text-field>

      <v-text-field
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        label="Naam dienst"
        v-model="newPackage.name"
        :rules="requiredRules"
        required
        hint="Machinename invullen. Zodat er gefilterd kan worden of de klant deze dienst al heeft."
        persistent-hint
      ></v-text-field>

      <v-select
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        style="margin: 15px 0;"
        v-model="newPackage.showTo"
        :items="showTo"
        label="Selecteer wie  dit pakket kan zien"
        item-text="name"
        item-value="id"
        prepend-inner-icon="visibility"
      ></v-select>

      <div
        v-if="newPackage.type != 'update'"
        class="upload-news-image-wrapper clear"
      >
        <div class="upload-image">
          <p>Upload afbeelding</p>
          <div v-if="newPackage.imageUrl" class="logo-upload-preview">
            <v-img
              :src="newPackage.imageUrl"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <div v-if="uploading == true" class="upload-bar">
              <p>{{ uploadProgress }} %</p>
              <div
                class="upload-bar-inner"
                v-bind:style="{ backgroundColor: companyPrimaryColor }"
              ></div>
            </div>
          </div>
          <v-btn
            class="ma-0"
            raised
            :color="companyPrimaryColor"
            dark
            @click="onFileSelect"
            >Kies afbeelding</v-btn
          >
          <input
            type="file"
            style="display: none;"
            ref="fileInput"
            accept="image/*"
            @change="onFilePicked"
          />
        </div>
      </div>

      <v-select
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        v-model="selectedDescriptionRole"
        :items="roles"
        label="Selecteer rol voor intro en omschrijving"
        item-text="name"
        item-value="id"
        prepend-icon="group"
        hint="Voeg een omschrijving toe per doelgroep voor optimale conversie."
        persistent-hint
      ></v-select>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <label class="custom-label">Intro voor {{ selectedRole }}</label>
        <ckeditor
          v-if="selectedDescriptionRole == 'admin'"
          type="classic"
          v-model="newPackage.intro.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
        <ckeditor
          v-if="selectedDescriptionRole == 'manager'"
          type="classic"
          v-model="newPackage.intro.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
        <ckeditor
          v-if="selectedDescriptionRole == 'employee'"
          type="classic"
          v-model="newPackage.intro.admin"
          :config="editorConfig"
          :upload-adapter="UploadAdapter"
        ></ckeditor>
      </div>

      <div class="field-wrapper" style="max-width: 100%; overflow: hidden;">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <label class="custom-label"
              >Omschrijving voor {{ selectedRole
              }}<v-icon v-on="on" small right :color="companyPrimaryColor"
                >help</v-icon
              ></label
            >
          </template>
          <span style="color: #fff;"
            >Omschrijving van de dienst voor {{ selectedRole }}.</span
          >
        </v-tooltip>
        <ckeditor
          v-if="selectedDescriptionRole == 'admin'"
          type="classic"
          :upload-adapter="UploadAdapter"
          v-model="newPackage.description.admin"
          :config="editorConfig"
        ></ckeditor>
        <ckeditor
          v-if="selectedDescriptionRole == 'manager'"
          type="classic"
          :upload-adapter="UploadAdapter"
          v-model="newPackage.description.managers"
          :config="editorConfig"
        ></ckeditor>
        <ckeditor
          v-if="selectedDescriptionRole == 'employee'"
          type="classic"
          :upload-adapter="UploadAdapter"
          v-model="newPackage.description.employees"
          :config="editorConfig"
        ></ckeditor>
      </div>

      <v-text-field
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        style="margin: 15px 0;"
        label="CTA -knop tekst"
        v-model="newPackage.cta"
        :rules="requiredRules"
        counter="20"
        required
      >
      </v-text-field>

      <v-select
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        :item-color="companyPrimaryColor"
        style="margin: 15px 0;"
        v-model="newPackage.ctaAction"
        :items="actions"
        label="CTA bestemming"
        item-text="name"
        item-value="id"
        prepend-inner-icon="link"
        hint="Wat gebeurd er bij het klikken op de CTA-knop"
        persistent-hint
      ></v-select>

      <div
        v-if="newPackage.ctaAction == 'customMessage'"
        class="field-wrapper"
        style="max-width: 100%; overflow: hidden; margin: 15px 0;"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <label class="custom-label"
              >Aangepast bericht<v-icon
                v-on="on"
                small
                right
                :color="companyPrimaryColor"
                >help</v-icon
              ></label
            >
          </template>
          <span style="color: #fff;"
            >Bericht wordt getoond als op de CTA-knop is geklikt</span
          >
        </v-tooltip>
        <ckeditor
          type="classic"
          v-model="newPackage.ctaActionDescription"
          :upload-adapter="UploadAdapter"
          :config="editorConfig"
        ></ckeditor>
      </div>

      <v-switch
        style="margin: 15px 0;"
        :color="companyPrimaryColor"
        v-model="newPackage.action"
        class="pa-0"
        hide-details
      >
        <template slot="label">
          <span style="color: #333; margin-right: 5px;">Actie</span>
          <v-tooltip class="ma-0 pa-0" right>
            <template v-slot:activator="{ on }">
              <v-icon small :color="companyPrimaryColor" v-on="on">help</v-icon>
            </template>
            <span style="color: #fff;"
              >Aanvinken wanneer er een speciale actie is.</span
            >
          </v-tooltip>
        </template>
      </v-switch>

      <v-text-field
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        style="margin: 0 0 15px 0;"
        label="Prijs"
        v-model="newPackage.price"
        :rules="requiredRules"
        required
      >
      </v-text-field>

      <v-text-field
        class="mt-4"
        outlined
        :color="companyPrimaryColor"
        v-if="newPackage.action"
        style="margin: 0 0 15px 0;"
        label="Beschrijving actie"
        v-model="newPackage.actionDescription"
        :rules="requiredRules"
        counter="15"
        hint="Wordt weergegeven boven CTA knop in tegel"
        persistent-hint
        required
      >
      </v-text-field>

      <v-switch
        :color="companyPrimaryColor"
        v-model="newPackage.published"
        class="pa-0"
        hide-details
      >
        <template slot="label">
          <span style="color: #333; margin-right: 5px;">Publiceren</span>
          <v-tooltip class="ma-0 pa-0" right>
            <template v-slot:activator="{ on }">
              <v-icon small :color="companyPrimaryColor" v-on="on">help</v-icon>
            </template>
            <span style="color: #fff;"
              >Bericht wordt alleen getoond aan gebruikers als deze gepubliceerd
              is.</span
            >
          </v-tooltip>
        </template>
      </v-switch>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddPackageDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addPackage()"
            >
              Package toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import { Chrome } from "vue-color";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import platform from "platform";

export default {
  name: "add-package-form",
  data() {
    return {
      editorConfig: {
        toolbar: [
          "heading",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "ImageUpload",
          "|",
          "insertTable",
          "|",
          "undo",
          "redo",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      publishDateDialog: false,
      valid: false,
      newPackage: {
        title: null,
        name: null,
        intro: {
          admin: "",
          manager: "",
          employee: "",
        },
        showTo: null,
        action: false,
        actionDescription: null,
        published: true,
        description: {
          admin: "",
          manager: "",
          employee: "",
        },
        cta: null,
        ctaAction: "callUs",
        ctaActionDescription: null,
        price: null,
        imageUrl: null,
      },
      selectedDescriptionRole: "admin",
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      valid: true,
      filename: null,
      image: null,
      showTo: [
        {
          name: "Iedereen",
          id: "all",
        },
        {
          name: "Kappers",
          id: "kapper",
        },
        {
          name: "Anders",
          id: "other",
        },
      ],
      actions: [
        {
          name: "Bel ons",
          id: "callUs",
        },
        {
          name: "Aangepast bericht",
          id: "customMessage",
        },
      ],
      roles: [
        {
          name: "Admins",
          id: "admin",
        },
        {
          name: "Managers",
          id: "manager",
        },
        {
          name: "Medewerkers",
          id: "employee",
        },
      ],
      feedback: null,
      uploading: false,
      uploadProgress: null,
      file: {},
    };
  },

  methods: {
    closeAddPackageDialog() {
      // Dialog sluiten en waardes resetten
      this.$emit("newPackageDialogChange", false);
      this.newPackage = {
        title: null,
        name: null,
        intro: {
          admin: "",
          manager: "",
          employee: "",
        },
        action: false,
        actionDescription: null,
        published: true,
        description: {
          admin: "",
          manager: "",
          employee: "",
        },
        cta: null,
        imageUrl: null,
      };
      this.feedback = null;
    },

    onFileSelect() {
      // Openen van selectievenster in browser
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      // Afbeelding selecteren
      const files = event.target.files;
      this.file = files[0];
      let filename = files[0].name;
      this.filename = filename;
      console.log("files: " + filename);
      if (filename.lastIndexOf(".") <= 0) {
        this.feedback = "Voeg een geldig bestand toe.";
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.newPackage.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
      this.feedback = null;
    },

    UploadAdapter(loader) {
      let token = Math.random()
        .toString(36)
        .substr(2);
      this.loader = loader;

      let company = "hogans";
      let imageUrl = "";
      loader.file.then((response) => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              (taskSnapshot) => {},
              (error) => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then((url) => {
                    imageUrl = url;
                    resolve();
                  })
                  .catch((error) => {
                    reject();
                  });
              },
            );
          }).then(() => {
            return {
              default: imageUrl,
            };
          });
        };
      });
    },

    addPackage() {
      // Package toevoegen
      this.feedback = null;

      if (
        this.newPackage.imageUrl &&
        this.newPackage.description.admin &&
        this.newPackage.intro.admin &&
        this.newPackage.title &&
        this.newPackage.name &&
        this.newPackage.cta
      ) {
        db.collection("packages")
          .add({
            title: this.newPackage.title,
            name: this.newPackage.name,
            intro: this.newPackage.intro,
            description: this.newPackage.description,
            cta: this.newPackage.cta,
            ctaAction: this.newPackage.ctaAction,
            ctaActionDescription: this.newPackage.ctaActionDescription,
            price: this.newPackage.price,
            showTo: this.newPackage.showTo,
            action: this.newPackage.action,
            actionDescription: this.newPackage.actionDescription,
            published: this.newPackage.published,
            publishDate: new Date(),
            user: this.userFirstName + " " + this.userLastName,
            views: [],
          })
          .then(async (docRef) => {
            if (this.filename) {
              await this.uploadPackageImage(docRef.id);
            }
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Pillarrr Dienst toegevoegd: " + this.newPackage.name,
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              extra:
                "<b>Titel</b>: " +
                this.newPackage.title +
                "<br>" +
                "<b>Omschrijving</b>: " +
                this.newPackage.intro.admin +
                "<br> " +
                this.newPackage.description.admin +
                "<br>" +
                "<b>CTA</b>: " +
                this.newPackage.cta +
                "<br>" +
                "<b>Gepubliceerd</b>: " +
                this.newPackage.published,
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddPackageDialog();
            console.log("Package succesfully added");
          });
      } else {
        this.feedback = "Vul alle velden in om een dienst toe te voegen.";
      }
    },

    uploadPackageImage(docId) {
      // Afbeelding uploaden en News doc updaten
      return new Promise((resolve, reject) => {
        console.log("start storen");
        const file = this.file;
        const filename = this.filename;
        const ext = filename.slice(filename.lastIndexOf("."));
        const fileUrl = "packages/" + docId + ext;
        this.uploading = true;
        let uploadTask = firebase
          .storage()
          .ref(fileUrl)
          .put(file);

        uploadTask.on(
          "state_changed",
          (taskSnapshot) => {
            var progress = Math.ceil(
              (taskSnapshot.bytesTransferred / taskSnapshot.totalBytes) * 100,
            );
            this.uploadProgress = progress;
          },
          (error) => {
            console.log(error);
            reject();
          },
          () => {
            console.log("The upload is compleet");
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((url) => {
                db.collection("packages")
                  .doc(docId)
                  .update({
                    imageUrl: url,
                  })
                  .then(() => {
                    resolve();
                    this.uploading = false;
                    this.uploadProgress = null;
                  })
                  .catch((error) => {
                    reject();
                    this.uploading = false;
                    this.uploadProgress = null;
                  });
              })
              .catch((error) => {
                reject();
                this.uploading = false;
                this.uploadProgress = null;
              });
          },
        );
      });
    },
  },

  computed: {
    selectedRole() {
      // Naam van de geselecteerde contenttype
      let roleType;
      this.roles.map((role) => {
        if (role.id == this.selectedDescriptionRole) {
          roleType = role.name.toLowerCase();
        }
      });
      return roleType;
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>

<style>
.custom-label {
  font-size: 16px;
  padding: 15px 0 5px;
  display: inline-block;
}

.upload-news-image-wrapper {
  padding: 20px 0;
}

.software-version-number {
  width: 35px;
  display: inline-block;
  margin: 4px 4px 4px 0;
  font-size: 14px;
  font-weight: bold;
}

.software-version-date {
  display: inline-block;
  font-size: 12px;
  width: 120px;
}
.software-version-author {
  display: inline-block;
  font-size: 12px;
  width: 110px;
}
</style>
